import type { TileData, TileKey, WorldState } from "../../models/worldState.ts";
import { revealTile } from "../map/tileVisibility.ts";
import { rejectCommand } from "../rejectCommand.ts";
import type { ReduceResult } from "../result.ts";
import { resolveAmbientWeather } from "../world/resolveAmbientWeather.ts";

export function reduceChooseStart(state: WorldState, tile: TileKey): ReduceResult {
  const chosen = state.tiles[tile];
  if (!chosen) {
    return rejectCommand(state, { type: "ChooseStart", tile }, "no-such-tile");
  }

  // Only the chosen tile is revealed — neighbours stay hidden until moved onto
  // (matches production chooseStart / legacy starting-tile flow).
  const tiles: Record<TileKey, TileData> = {
    ...state.tiles,
    [tile]: revealTile({
      ...chosen,
      isStartingTile: true,
    }),
  };

  const ambientWeather = resolveAmbientWeather(state.turn, chosen.terrain);

  const revealedTileCount = Object.values(tiles).filter(
    (entry) => entry.visibility === "revealed",
  ).length;

  return {
    state: {
      ...state,
      phase: "settling",
      tiles,
      clan: {
        ...state.clan,
        currentTile: { q: chosen.q, r: chosen.r },
        movedThisTurn: false,
        ambientWeather,
      },
    },
    events: [
      {
        type: "StartTileSelected",
        terrain: chosen.terrain,
        q: chosen.q,
        r: chosen.r,
        revealedTileCount,
      },
    ],
  };
}
